/**
 * @typedef {Object} EventListeners
 * @property {StoreEventCallback} [click] event handler function for `click` google maps event.
 * @property {StoreEventCallback} [mousedown] event handler function for `mousedown` google maps event.
 * @property {StoreEventCallback} [mouseout] event handler function for `mouseout` google maps event.
 * @property {StoreEventCallback} [mouseover] event handler function for `mouseover` google maps event.
 * @property {StoreEventCallback} [mouseup] event handler function for `mouseup` google maps event.
 */

/**
 * @typedef {Object} RendererOptions
 * @property {StoreEventListener} [click] The click callback.
 * @property {EventListeners} eventListeners
 * @property {woosmap.style.Styler} styler
 */

module.exports = {
    DefaultRenderer: require("./defaultrenderer"),
    MarkersRenderer: require("./markersrenderer"),
    BaseRenderer: require("./base_renderer"),
};
